import React from 'react';
import Slider from 'react-slick';
import Card from '../Card/Card';
import './Carousel.scss';

export default function Carousel({ cards }) {
  const settings = {
    className: "center",
    lazyLoad: true,
    infinite: true,
    centerPadding: "30px",
    slidesToShow: 3,
    swipe: false,
    accessibility: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          swipe: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true
        }
      }
    ]
  };
  
  return (
    <Slider {...settings}>
      {cards.map((card, index) => (
        <div key={index}>
          <Card {...card} />
        </div>
      ))}
    </Slider>
  );
}
